"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Trybe
 * This site provides documentation on how to use the Trybe Shop API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var runtime_1 = require("../runtime");
var _1 = require("./");
/**
* @export
* @enum {string}
*/
var AppointmentSlotNoAvailabilityReasonEnum;
(function (AppointmentSlotNoAvailabilityReasonEnum) {
    AppointmentSlotNoAvailabilityReasonEnum["TimePassed"] = "time_passed";
    AppointmentSlotNoAvailabilityReasonEnum["DatePassed"] = "date_passed";
    AppointmentSlotNoAvailabilityReasonEnum["NoLongerBookable"] = "no_longer_bookable";
    AppointmentSlotNoAvailabilityReasonEnum["NotYetBookable"] = "not_yet_bookable";
    AppointmentSlotNoAvailabilityReasonEnum["PartnerSlotNotAvailable"] = "partner_slot_not_available";
    AppointmentSlotNoAvailabilityReasonEnum["PartnerOfferingNotAllowed"] = "partner_offering_not_allowed";
    AppointmentSlotNoAvailabilityReasonEnum["StartTimeNotAllowed"] = "start_time_not_allowed";
    AppointmentSlotNoAvailabilityReasonEnum["NoEquipmentAvailable"] = "no_equipment_available";
    AppointmentSlotNoAvailabilityReasonEnum["NoRoomsAvailable"] = "no_rooms_available";
    AppointmentSlotNoAvailabilityReasonEnum["NoPractitionersAvailable"] = "no_practitioners_available";
    AppointmentSlotNoAvailabilityReasonEnum["InvalidOfferingSettings"] = "invalid_offering_settings";
    AppointmentSlotNoAvailabilityReasonEnum["NotOfferedOnDate"] = "not_offered_on_date";
})(AppointmentSlotNoAvailabilityReasonEnum = exports.AppointmentSlotNoAvailabilityReasonEnum || (exports.AppointmentSlotNoAvailabilityReasonEnum = {}));
function AppointmentSlotFromJSON(json) {
    return AppointmentSlotFromJSONTyped(json, false);
}
exports.AppointmentSlotFromJSON = AppointmentSlotFromJSON;
function AppointmentSlotFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'start_time': (new Date(json['start_time'])),
        'end_time': (new Date(json['end_time'])),
        'duration': json['duration'],
        'end_buffer': json['end_buffer'],
        'practitioner_ids': json['practitioner_ids'],
        'room_ids': !runtime_1.exists(json, 'room_ids') ? undefined : json['room_ids'],
        'equipment_ids': !runtime_1.exists(json, 'equipment_ids') ? undefined : json['equipment_ids'],
        'suggested_combinations': !runtime_1.exists(json, 'suggested_combinations') ? undefined : (json['suggested_combinations'].map(_1.SuggestedCombinationFromJSON)),
        'total_quantity': json['total_quantity'],
        'quantity_available': json['quantity_available'],
        'is_valid': !runtime_1.exists(json, 'is_valid') ? undefined : json['is_valid'],
        'price': json['price'],
        'currency': json['currency'],
        'nonoptimal_practitioner_allocation': !runtime_1.exists(json, 'nonoptimal_practitioner_allocation') ? undefined : json['nonoptimal_practitioner_allocation'],
        'nonoptimal_practitioner_ids': !runtime_1.exists(json, 'nonoptimal_practitioner_ids') ? undefined : json['nonoptimal_practitioner_ids'],
        'no_availability_reason': !runtime_1.exists(json, 'no_availability_reason') ? undefined : json['no_availability_reason'],
        'no_availability_message': !runtime_1.exists(json, 'no_availability_message') ? undefined : json['no_availability_message'],
        'bookable_from': (json['bookable_from'] === null ? null : new Date(json['bookable_from'])),
        'bookable_to': (json['bookable_to'] === null ? null : new Date(json['bookable_to'])),
    };
}
exports.AppointmentSlotFromJSONTyped = AppointmentSlotFromJSONTyped;
function AppointmentSlotToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'start_time': (value.start_time.toISOString()),
        'end_time': (value.end_time.toISOString()),
        'duration': value.duration,
        'end_buffer': value.end_buffer,
        'practitioner_ids': value.practitioner_ids,
        'room_ids': value.room_ids,
        'equipment_ids': value.equipment_ids,
        'suggested_combinations': value.suggested_combinations === undefined ? undefined : (value.suggested_combinations.map(_1.SuggestedCombinationToJSON)),
        'total_quantity': value.total_quantity,
        'quantity_available': value.quantity_available,
        'is_valid': value.is_valid,
        'price': value.price,
        'currency': value.currency,
        'nonoptimal_practitioner_allocation': value.nonoptimal_practitioner_allocation,
        'nonoptimal_practitioner_ids': value.nonoptimal_practitioner_ids,
        'no_availability_reason': value.no_availability_reason,
        'no_availability_message': value.no_availability_message,
        'bookable_from': (value.bookable_from === null ? null : value.bookable_from.toISOString()),
        'bookable_to': (value.bookable_to === null ? null : value.bookable_to.toISOString()),
    };
}
exports.AppointmentSlotToJSON = AppointmentSlotToJSON;
